module.exports = __webpack_public_path__ + "img/banner3.8dd7f256.png";